import { buildClarityWorkspaceUrl } from './build-clarity-workspace-url.util';
import {
	readClarityWorkspaceRoute,
	toClaritySectionUrl,
	toNavigationUnlessCurrent,
} from './clarity-workspace-route.util';
import type { ClarityWorkspaceNavigation } from './models/clarity-workspace-navigation.model';

/** Ported from Clarity `apps/web/src/shared/hooks/useWorkspaceRoute.ts` (commit `f9217bb5a`). */
/**
 * Opening a domain — brain's `goToDomain(domainId)`: a **push** to `/<section>/d/<domainId>/pulse` that
 * drops `doc`, `page`, `file`, `oi`, `action` and the legacy `domain` / `tab`, carries every other query
 * key (every `sd_*` included) verbatim, and is `null` — no navigation — when that URL is `currentUrl`
 * (their TR-014).
 *
 * Only the integration is adapted: the current URL is an argument read at call time, the answer sits
 * under `sectionPath`, and the navigation is handed back rather than performed. Brain's
 * `goToDomain(null)` — the bounce to its resolver — is not here.
 */
export function toClarityDomainNavigation(
	currentUrl: string,
	sectionPath: string,
	domainId: string,
): ClarityWorkspaceNavigation | null {
	const current = readClarityWorkspaceRoute(currentUrl, sectionPath);
	const url = buildClarityWorkspaceUrl(
		{ domainId, tab: 'pulse', doc: null, page: null, file: null, oi: null, action: null },
		current.search,
	);

	return toNavigationUnlessCurrent(current, toClaritySectionUrl(sectionPath, url), false);
}
